import { render, staticRenderFns } from "./PlanAndBilling.vue?vue&type=template&id=55cf0652&scoped=true"
import script from "./PlanAndBilling.vue?vue&type=script&lang=js"
export * from "./PlanAndBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf0652",
  null
  
)

export default component.exports